// For use with quasar and vuelidate
export default {
  methods: {
    getErrorState(path) {
      if (!path) {
        throw new Error('Validation not found');
      }

      return path.$invalid && path.$dirty;
    },
  },
};
